import { render, staticRenderFns } from "./IndustryBenefitTextBox.vue?vue&type=template&id=45b373b0&scoped=true&"
import script from "./IndustryBenefitTextBox.vue?vue&type=script&lang=js&"
export * from "./IndustryBenefitTextBox.vue?vue&type=script&lang=js&"
import style0 from "./IndustryBenefitTextBox.vue?vue&type=style&index=0&id=45b373b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b373b0",
  null
  
)

export default component.exports